import SasicAdvert from './SasicAdvert';

const Leader: React.FC = () => {
  const superTag = 'leader';

  return (
    <div className="flex flex-col items-center justify-center lg:h-[210px]">
      <SasicAdvert elementId={superTag} supertag={superTag} pos={1} />
    </div>
  );
};

export default Leader;
